import { inject, Injectable, NgZone } from '@angular/core';
import { EnvironmentService } from '@core/services/environment.service';
import lazySizes from 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';

lazySizes.cfg.init = false;

@Injectable({
    providedIn: 'root',
})
export class LazysizesService {
    private zone = inject(NgZone);
    private environmentService = inject(EnvironmentService);
    constructor() {
        if (this.environmentService.isBrowser()) {
            this.zone.runOutsideAngular(() => {
                lazySizes.init();
            });
        }
    }
}
